import React from "react";

import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import shareto from "views/job-details/img/upload.png";
import referingbanner from "views/job-details/img/referingbanner.png";
import pin from "views/job-details/img/pin.svg";
const App = (props) => {
  const [open, setOpen] = React.useState(false);
  // console.log(props.showRefer);
  return (
    <>
      <Modal
        center
        open={props.showRefer}
        onClose={() => setOpen(false)}
        classNames={{
          modal: "refermodal-w",
        }}
      >
        <div className="refer-modal p-4 ">
          <div>
            <h2 className="refer-h2 uppercase">
              Help your friend get a career at ICICI
            </h2>
          </div>

          <div className="flex">
            <form action="" className="w-1/2">
              <div class="form-group modal-form-cs">
                <label for="">Name</label>
                <input type="text" placeholder="" value="Full Name" />
              </div>
              <div class="form-group pt-4 modal-form-cs">
                <label for="">Mobile Number</label>
                <input type="text" placeholder="" value="9867654327" />
              </div>

              <div class="form-group pt-4 modal-form-cs">
                <label for="">Email</label>
                <input type="text" placeholder="" value="info@gmail.com" />
              </div>

              <div class="form-group mt-8 modal-form-cs w-full h-90px justify-center items-center flex  bord-radius">
                <div>
                  <img src={shareto} className="m-auto" />
                  <p className="fsize16 text-black pt-2">Upload Resume</p>
                </div>
              </div>

              <div class="w-full fixed-btn mt-6">
                <a class="btn btn-orange-otp btn-otp mx-auto myBtn" href="#">
                  REFER FRIEND
                </a>
              </div>
            </form>

            <div className="w-1/2 pl-8">
              <p className="fsize14 mb-3">Referring Job</p>

              <card className="rounded-12px drop-shadow block">
                <img src={referingbanner} />
                <div className="p-6">
                  <h1 className="fsize18 font-bold">Phone Banking Officer</h1>

                  <div>
                    <p className="fsize12 color-lgrey mt-2">
                      Required Experience:
                      <span className="text-black  font-bold"> 1-3 years</span>
                    </p>
                    <p className="fsize12 color-lgrey mt-1">
                      Education:
                      <span className="text-black  font-bold"> CA</span>
                    </p>
                  </div>
                  <p className="dashed-border-b mt-4"></p>

                  <div className="flex justify-start items-center mt-4">
                    <div className="flex items-center">
                      <img src={pin} className="pn-icon-w" />

                      <p className="text-muted-400 ml-2">Mumbai</p>
                    </div>
                    <span className="dot-point bg-bluecolor rounded-full mx-4 "></span>
                    <p className="text-muted-400">3d ago</p>
                  </div>
                  <p className="underline fsize14 text-orange-c mt-6">
                    View Details
                  </p>
                </div>
              </card>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default App;
